import { ChevronDown } from "lucide-react";
import { PropsWithChildren, ReactNode } from "react";
import {
  Button,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  cn,
} from "web-design-system";

export function OverviewSection(
  props: PropsWithChildren<{
    label?: string;
    header?: ReactNode;
    className?: string;
    defaultOpen?: boolean;
  }>
) {
  const { label, header, children, defaultOpen, className } = props;

  return (
    <Collapsible
      defaultOpen={defaultOpen}
      className={cn(
        "rounded-lg flex flex-col group bg-card gap-4 p-4",
        className
      )}
    >
      <CollapsibleTrigger asChild>
        {header ? (
          <div className="relative flex min-h-9 w-full items-center">
            <div className="w-full">{header}</div>
            <Button
              variant="outline"
              size="icon"
              className="absolute top-1/2 right-0 shrink-0 -translate-y-1/2"
            >
              <ChevronDown className="group-data-[state=open]:rotate-180 size-4" />
            </Button>
          </div>
        ) : (
          <div className="flex min-h-9 items-center gap-4 w-full">
            {label ? (
              <span className="text-base font-semibold flex-1">{label}</span>
            ) : (
              <div className="flex-1" />
            )}
            <Button variant="outline" size="icon" className="shrink-0">
              <ChevronDown className="group-data-[state=open]:rotate-180 size-4" />
            </Button>
          </div>
        )}
      </CollapsibleTrigger>
      <CollapsibleContent className="bg-inherit">{children}</CollapsibleContent>
    </Collapsible>
  );
}
